// import veryhash from './veryhash';
// import hashnest from './hashnest';
import nicehash from './nicehash';
import cloudMining from './cloud-mining';
import lifetime from './lifetime';
import ftx from './ftx';

export default { veryhash: lifetime, hashnest: lifetime, nicehash, cloudMining, lifetime, ftx, FTX: ftx }